import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as partnerApi from '../../lib/api/partner';

const [LIST_PARTNERS, LIST_PARTNERS_SUCCESS, LIST_PARTNERS_FAILURE] =
  createRequestActionTypes('partner/LIST_PARTNERS');
export const listPartners = createAction(
  LIST_PARTNERS,
  (searchData) => searchData,
);
const listPartnersSaga = createRequestSaga(
  LIST_PARTNERS,
  partnerApi.getPartners,
);

export function* partnersSaga() {
  yield takeLatest(LIST_PARTNERS, listPartnersSaga);
}

const initialState = {
  partners: null,
  error: null,
};

const partners = handleActions(
  {
    [LIST_PARTNERS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      partners: data.list.map((partner) => ({
        id: partner.partnerUuid,
        partnerUuid: partner.partnerUuid,
        partnerNm: partner.partnerNm,
        regNumber: partner.regNumber,
        partnerTyp: partner.partnerTyp,
        incTyp: partner.incTyp,
        partnerPhone: partner.partnerPhone,
        partnerAddr: partner.partnerAddr,
        loanAmt: partner.loanAmt,
        creditRating: partner.creditRating,
        crtNm: partner.crtNm,
        crtDt: partner.crtDt,
        cngNm: partner.cngNm,
        cngDt: partner.cngDt,
      })),
      error: null,
    }),
    [LIST_PARTNERS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
  },
  initialState,
);

export default partners;
